import React from 'react';
import {useAutoList} from '@netx/core-next/hooks/autoList/useAutoList';
import {i18n} from '@netx/core-next/locales/i18n-instance';
import {AutoListField} from '@netx/core-components/AutoListField';
import type {SemanticValue} from '@netx/core-asset/models/attribute';
import type {CommonProps} from '../../types';
import {getSemanticObjectAutoList} from '../../../../api';
import {usePlaceholder} from '../../../../hooks';

const DEFAULT_VALUE: string[] = [];

export interface SemanticAttributeProps extends CommonProps<SemanticValue> {}

export const SemanticAttributePrimitive = ({
	action,
	attrData,
	hideLabel,
	isMetadataTarget,
	multipleValues,
	placeholder,
	readOnly,
	value,
	// so it does no get passed along
	// only some of our attribute types are offer folksonomy
	disableFolksonomy,
	// only some of our attribute types are offer lookup
	isMetadataLookup,
	onLookup,
	...props
}: SemanticAttributeProps) => {
	const cleared = action === 'clear';
	const defaultValue = value == null ? DEFAULT_VALUE : value;

	const {loadingOptions, query, queryStr, setQueryStr, setIsOpen} = useAutoList(
		{
			params: {id: attrData.semanticTypeId},
			queryFn: getSemanticObjectAutoList,
		},
	);

	const textfieldPlaceholder = usePlaceholder(
		attrData,
		placeholder !== '' ? placeholder : i18n.t('i18n.typeToAddSemantics'),
		{
			cleared,
			multipleValues,
			readOnly,
			value: defaultValue,
		},
	);

	return (
		<AutoListField<string, true>
			hideErrorMessage
			id={attrData.attributeid.toString()}
			label={hideLabel ? undefined : attrData.name}
			loadingOptions={loadingOptions}
			name={attrData.name}
			{...props}
			inputValue={queryStr}
			multiple
			options={(query.data ?? []).map((result) => result.label)}
			placeholder={textfieldPlaceholder}
			readOnly={readOnly}
			value={defaultValue}
			onClose={() => setIsOpen(false)}
			onOpen={() => setIsOpen(true)}
			onInputChange={(event, value, reason) => setQueryStr(value)}
			InputProps={{
				InputLabelProps: {
					shrink: multipleValues || cleared ? true : undefined,
				},
			}}
		/>
	);
};

export const SemanticAttribute = React.memo(SemanticAttributePrimitive);

export default SemanticAttribute;
